import { Box, ButtonBase, Tag, Typography } from '@/shared/ui';

import { pluralizeUnit } from '@/shared/lib/format/getAmountLabel';
import Tabs from '@/shared/ui/primitives/Tabs';

const catalogTabs = [
  { name: 'Spot', label: 'Spot' },
  { name: 'Forward curves', label: 'Forward Curves' }
];

type CatalogHeroProps = {
  count: number;
  newCount: number;
  unit: string;
  activeTab: number;
  onTabChange: () => void;
  onNewClick: () => void;
};

const CatalogHero = ({
  count,
  newCount,
  unit,
  activeTab,
  onTabChange,
  onNewClick
}: CatalogHeroProps) => (
  <Box
    sx={{
      display: 'flex',
      width: '100%',
      my: 3,
      justifyContent: 'space-between',
      alignItems: 'flex-end'
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Typography
        noWrap
        component='h2'
        sx={{ fontSize: '24px', fontWeight: 700, color: 'gx.text', lineHeight: 'normal' }}
      >
        Catalog
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            color: 'gx.subtext',
            fontSize: '16px'
          }}
        >
          <Box
            component='span'
            sx={{ fontWeight: 700 }}
          >
            {count.toLocaleString('en-US')}
          </Box>
          <Box
            component='span'
            sx={{ fontWeight: 500 }}
          >
            {pluralizeUnit(count, unit)}
          </Box>
        </Box>
        {newCount > 0 && (
          <ButtonBase
            sx={{ borderRadius: '2px' }}
            onClick={onNewClick}
          >
            <Tag
              label={`${newCount} NEW`}
              tone='new'
            />
          </ButtonBase>
        )}
      </Box>
    </Box>
    <Tabs
      activeTab={activeTab}
      minTabWidth={200}
      tabs={catalogTabs}
      onChange={onTabChange}
    />
  </Box>
);

export default CatalogHero;
